<template>
    <div class="wrapper mycustomdrive">
        <SideMenu />
        <div class="sidebar-body-wrapper">
            <HeaderLayout />
            <div class="content-page admin-content-wrap">
                <div class="container-fluid">
                    <router-view :key="$route.fullPath" />
                </div>
            </div>
        </div>
    </div>
        <!-- <Footer /> -->
</template>
<script>
import HeaderLayout from './Header.vue'
import SideMenu from './SideMenu.vue'
// import Footer from './Footer.vue'
import axios from 'axios'
import $ from "jquery";
export default {
    name: 'AdminLayout',
    components: {
        SideMenu,
        // Footer,
        HeaderLayout
    },
    computed: {
        iRt() {
            return this.$store.state.isRefreshToken
        },
    },
    watch: {
        async iRt(newValue) {
            await this.refreshToken()
            return newValue
        },
    },
    async mounted() {
        if (this.$store.state.attemptLogin == 2) {
            this.$toast.success('Login successfully');
            this.$store.state.attemptLogin = 1;
        }
        $(document).on('click', ".wrapper-menu", function() {
            $("body").toggleClass("sidebar-main");
        });
        this.refreshToken()
    },
    methods: {
        async refreshToken() {
            if (this.$store.state.user.accessToken == '') {
                let token = localStorage.getItem('mDrivetoken');
                if (token) {
                    this.$store.state.user.accessToken = token
                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.user.accessToken;
                    await axios.get(process.env.VUE_APP_API_URL + 'authenticate/user-details')
                    .then((resp) => {
                        if (typeof resp.data.data == 'undefined'){
                            this.$store.state.user.accessToken = ''
                            this.$store.state.isActiveToken = ''
                            this.$store.state.user.userInfo = ''
                            localStorage.removeItem("userInfo");
                            localStorage.removeItem("mDrivetoken");
                            this.$toast.success('Your login session has expired for security reasons. Please log in again to continue.')
                            this.$router.push({
                                name: 'Login'
                            })
                        }
                        else if (resp.status == 200 && resp.data.status == 'success' && resp.data.data != '')                      {             
                            this.$store.state.user.userInfo = resp.data.data
                            this.$store.state.user.roleId = resp.data.data.role_id
                            // this.$store.state.user.role_name = resp.data.data.role
                            this.$store.state.user.role_name = resp.data.data.role_name
                            // this.$store.state.user.role_name = 'user'
                            this.$store.state.isActiveToken = 1
                            this.$store.state.isRefreshToken = 1
                            // console.log(this.$store.state.user.role_name)
                            // if (this.$route.name === 'Company') {
                            //     this.$router.push({ name: 'Home' })
                            // }
                        }
                        else if (resp.status == 200 && resp.data.status == 'failure') {
                            // this.errorMessage = resp.data.data;
                            // this.errorRes = resp.data.message;
                            this.$store.state.user.accessToken = ''
                            this.$store.state.isActiveToken = ''
                            this.$store.state.user.userInfo = ''
                            localStorage.removeItem("userInfo");
                            localStorage.removeItem("mDrivetoken");
                            this.$toast.success('Your login session has expired for security reasons. Please log in again to continue.')
                            this.$router.push({
                                name: 'Login'
                            })
                        } else {
                            this.$toast.success('Your login session has expired for security reasons. Please log in again to continue.')
                            this.$router.push({
                                name: 'Login'
                            })
                        }
                    })
                    .catch(error => {
                        this.errorMessage = error.message;
                        this.$store.state.user.accessToken = ''
                        this.$store.state.user.userInfo = ''
                        localStorage.removeItem("userInfo");
                        localStorage.removeItem("mDrivetoken");    
                        this.$router.push({
                            name: 'Login'
                        })
                    })
                }
            }
        }
    },
}
</script>